import { ModalAddArticleComponent } from './../../../shared/components/modals/modal-add-article/modal-add-article.component';
import { ModalInfoOkComponent } from './../../../shared/components/modals/info-ok/modal-info-ok.component';
import { Component, EventEmitter, Injector, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyPaginator as MatPaginator, LegacyPageEvent as PageEvent } from '@angular/material/legacy-paginator';
import { Sort } from '@angular/material/sort';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ReferentielDTO } from 'src/app/shared/dtos/referentielDTO';
import { SimpleQueryResponse } from 'src/app/shared/dtos/simpleQueryResponse';
import { SimpleQueryUser } from 'src/app/shared/dtos/simpleQueryUser';
import { SocieteModel } from 'src/app/shared/models/simple-types/societe.model';
import { ArticleModel } from 'src/app/shared/models/societe-linked/article.model';
import { SocieteService } from 'src/app/shared/services/simple/societe.service';
import { ArticleService } from 'src/app/shared/services/societe-linked/article.service';
import { TrieTabService } from 'src/app/shared/services/utilities/trie-tab.service';
import { DetailReferentielInfos, GestionReferentielComponentService } from '../gestion-referentiel-component.service';
import { StateService } from 'src/app/shared/services/state.service';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-gestion-article',
  templateUrl: './gestion-article.component.html',
  styleUrls: ['./gestion-article.component.scss']
})
export class GestionArticleComponent {

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdated = new EventEmitter<boolean>();
  societe: SocieteModel;
  mySubscription: any;
  result = false;
  loading = false;
  selectedAction: ArticleModel;
  // tslint:disable-next-line: max-line-length
  displayedColumns: string[] = ['code', 'libelle', 'codeSite', 'codeNa', 'codeCg', 'codeTva', 'codeCategorie' , 'famille' , 'domaine' , 'pu', 'commun', 'action'];
  dataSource: ArticleModel[];
  matDataSource = new MatTableDataSource<ArticleModel>();
  pageEvent: PageEvent;
  sortState: Sort = {active: 'code', direction: 'desc'};
  length: number;
  pageIndex: number;
  pageSize = 25;
  droitLevel = 0;
  objet: SimpleQueryUser = new SimpleQueryUser();
  articles: ArticleModel[] = [];
  referentiel: DetailReferentielInfos;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router,
              public dialog: MatDialog,
              private route: ActivatedRoute,
              private articleService: ArticleService,
              private societeService: SocieteService,
              private toastrService: ToastrService,
              private gestionReferentielComponent: GestionReferentielComponentService,
              private state: StateService)
              {
                this.route.params.subscribe((params: any) => {
                  if (params.id === '0') {
                    this.toastrService.error('Erreur durant la récupération de l\'article.', 'Erreur');
                    this.router.navigate(['/']);
                  } else {
                    this.societeService.get(params.id).subscribe((societe: SocieteModel) => {
                      if (societe) {
                        this.societe = societe;
                        this.objet.query = '';
                        this.objet.pageNumber = 0;
                        this.objet.pageSize = this.pageSize;
                        this.objet.order = 'libelle';
                        this.matDataSource.paginator = this.paginator;
                        this.state.changeSociety(societe);
                        this.loadPage();
                        this.gestionReferentielComponent.loadDetailReferentiel().subscribe(referentiel => {
                          this.referentiel = referentiel;
                        });
                      }
                    });
                  }
                });
                this.router.routeReuseStrategy.shouldReuseRoute = function() {
                   return false;
                 };
                this.mySubscription = this.router.events.subscribe((event) => {
                   if (event instanceof NavigationEnd) {
                     this.router.navigated = false;
                   }
                 });
              }


  onCreate(): void {
    const form = this.gestionReferentielComponent.getCreateArticleFormGroup();
    form.get('idSociete').setValue(this.societe.id);
    const dialogRef = this.dialog.open(ModalAddArticleComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          referentiel: this.referentiel,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });

  }

  onModify(article: ArticleModel): void {
    const form = this.gestionReferentielComponent.getEditArticleFormGroup(article);
    const dialogRef = this.dialog.open(ModalAddArticleComponent, {
        autoFocus: false,
        disableClose: true,
        data: {
          societeId: this.societe.id,
          form,
          referentiel: this.referentiel,
          famille: article.ssFamille,
          domaine: article.ssDomaine,
          result: this.result
        }
      });

    dialogRef.afterClosed().subscribe(result => {
        this.onUpdated.emit(true);
        if (result) {
         this.loadPage();
        }
      });
  }


  onDelete(article: ArticleModel): void {
    const dialogRef = this.dialog.open(ModalInfoOkComponent, {
      data: {
        title: 'Suppression de l\'article',
        message: 'Êtes-vous sur de vouloir supprimer l\'article ?',
        icone: 'warning_amber',
        iconColor: 'accent',
        color: 'accent'
      }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.articleService.delete(article.id).subscribe((response: ArticleModel) => {
          this.toastrService.success('L\'article a bien été supprimé');
          this.loadPage();
        });
      }
    });
  }

  getNaByCode(code: string): string{
    const na = this.referentiel.nas.find(n => n.code === code);
    if (na) {
      return na.code + '-' + na.libelle;
    } else {
      return '';
    }
  }

  getSitebyCode(code: string): string{
    const site = this.referentiel.sites.find(s => s.code === code);
    if (site) {
      return site.code + '-' + site.libelle;
    } else {
      return '';
    }
  }

  getTvaByCode(code: string): string{
    const tva = this.referentiel.tvas.find(t => t.code === code);
    if (tva) {
      return tva.code + '-' + tva.libelle;
    } else {
      return '';
    }
  }

  getCgByCode(code: string): string{
    const cgCarge = this.referentiel.cgCharges.find(cg => cg.code === code);
    if (cgCarge) {
      return cgCarge.code + '-' + cgCarge.libelle;
    } else {
      return '';
    }
  }

  getCatgorieByCode(code: string): string{
    const categorie = this.referentiel.categories.find(c => c.code === code);
    if (categorie) {
      return categorie.code + '-' + categorie.libelle;
    } else {
      return '';
    }
  }

  orderUsers(articles: ArticleModel[]): ArticleModel[] {
    articles = articles.sort((a, b) => {
      if (a.libelle) {
        return a.libelle.localeCompare(b.libelle);
      } else {
        return -1;
      }
    });
    return articles;
  }


  changePage(event?: PageEvent): void {
    this.objet.pageNumber =  event.pageIndex;
    this.objet.pageSize = event.pageSize;
    this.loadPage();
  }

  search(): void {
    this.objet.pageNumber = 0;
    this.objet.pageSize = this.pageSize;
    this.paginator.pageIndex = 0;
    this.loadPage();
  }

  loadPage(): void {
    const referentiel = new ReferentielDTO();
    referentiel.objet = this.objet;
    referentiel.idSociete = this.societe.id;
    this.articleService.loadFromSimpleQueryAdmin(referentiel).subscribe((query: SimpleQueryResponse<ArticleModel>) => {
      if (query.objets != null) {
        this.articles = query.objets;
      } else {
        this.articles = [];
      }
      this.length = query.count;
      this.matDataSource = new MatTableDataSource<ArticleModel>(this.articles);
    });
  }

  onLeave(): void {
    this.router.navigate(['/gestion-referentiel']);
  }

  sortData(sort: Sort): void {
    if (sort.direction !== 'asc') {
      this.objet.descending = false;
    } else {
      this.objet.descending = true;
    }
    this.sortState = sort;
    this.objet.order = sort.active;
    this.loadPage();
  }
}
